import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { settings } from '../../../settings';
import { loginType } from '../../models/Interfaces/login';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  isloggedIn: any = false;
  api = settings.API_URL;
  constructor(private http: HttpClient) {}

  loginRequest(loginParams: loginType): Observable<any> {
    return this.http.post(this.api + '/api/login/company', loginParams);
  }

  loginReceived(data: any) {
    return console.log(data);
  }

  isAuthenticatedUser() {
    if (typeof localStorage !== 'undefined') {
      return JSON.parse(localStorage.getItem('isLoggedIn') || 'false');
    }
    return false;
  }

  termsAndConditions(params: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    if (params.requestType === 'SHCH') {
      return this.http.post(
        this.api +
          `/api/ackUserDocuments/scheduleOfCharges?sessionHash=${
            params?.params
          }`,
        { headers },
      );
    } else if (params.requestType === 'RLRG') {
      return this.http.post(
        this.api +
          `/api/ackUserDocuments/rulesAndRegulations?sessionHash=${
            params?.params
          }`,
        { headers },
      );
    }
    return throwError(() => new Error('Invalid request type'));
  }
}
